import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import Accordion from '@material-ui/core/ExpansionPanel';
import AccordionDetails from '@material-ui/core/ExpansionPanelDetails';
import AccordionSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import Edit from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';

import { translate } from 'services/i18nService';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import ContentCard from 'components/ContentCard/ContentCard';
import routeDefinitions from 'enum/routeDefinitions';
import { generateID, shouldShowEditButton } from 'utils/helpers';

import styles from './ProfileSexQuestionnaire.css';


const IDS = {
  prefix: 'HTTPzS11',
  element: 'ProfileSexQuestionnaire',
  accordion: 'accordion',
};
const makeId = generateID(IDS.prefix, IDS.element);

const ProfileSexQuestionnaire = () => {
  useEffect(() => ProfileStore.getSexQuestionnaire(), []);
  const [expanded, setExpanded] = useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const { sexQuestionnaires, hasSexQuestionnaires, profileName } = ProfileStore;
  const { user } = UserStore;

  function renderSexQuestionnaires() {
    return (
      sexQuestionnaires &&
      sexQuestionnaires.map((questionnaire) => {
        const { questionnaireId } = questionnaire;
        const hasAnswer = questionnaire.answer && questionnaire.answer.length;

        return hasAnswer ? (
          <Grid key={questionnaireId} item={true} md={6} xs={12}>
            <Accordion
              classes={{ root: styles.accordionRoot }}
              expanded={expanded === `panel-${questionnaireId}`}
              id={`${makeId(IDS.accordion)}_${questionnaireId}`}
              onChange={handleChange(`panel-${questionnaireId}`)}
            >
              <AccordionSummary
                aria-controls={`panel${questionnaireId}bh-content`}
                classes={{ expanded: styles.accordionTitleExpanded }}
                expandIcon={<ExpandMoreIcon />}
                id={`panel${questionnaireId}bh-header${questionnaireId}`}
              >
                <Typography className={styles.heading}>
                  {translate(`questionnaire.questionnaire.${questionnaireId}`)}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className={styles.answer}>{questionnaire.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          </Grid>
        ) : null;
      })
    );
  }
  const route = routeDefinitions.get(routeDefinitions.profileSettingsRoutes.info, { username: user.username });

  const title = shouldShowEditButton(user, profileName) ? (
    <div className={styles.flexContainer}>
      <div>{translate('v2profile.title.sex.questionnaire')}</div>
      <Link to={route}>
        <Edit className={styles.editIcon} />
      </Link>
    </div>
  ) : (
    translate('v2profile.title.sex.questionnaire')
  );

  return hasSexQuestionnaires ? (
    <ContentCard className={styles.contentCard} contentClass={styles.contentClass} title={title}>
      <Grid container={true} spacing={2}>
        {renderSexQuestionnaires()}
      </Grid>
    </ContentCard>
  ) : null;
};

export default observer(ProfileSexQuestionnaire);
